<template>
    <div class="loading-overlay">
      <div class="loader">
        <div class="loader-orbit">
          <div class="orbit-circle orbit-circle--outer"></div>
          <div class="orbit-circle orbit-circle--middle"></div>
          <div class="orbit-circle orbit-circle--inner"></div>
          <div class="loader-dot"></div>
        </div>
        <div class="loader-text">
          Lädt<span class="loader-dots">
            <span>.</span><span>.</span><span>.</span>
          </span>
        </div>
      </div>
    </div>
  </template>
  
  <style scoped>
  /* Hintergrund: rein weiß */
  .loading-overlay {
    position: fixed;
    inset: 0;
    background: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
  }
  
  /* Container */
  .loader {
    text-align: center;
    color: #444;
    font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  }
  
  .loader-orbit {
    width: 120px;
    height: 120px;
    position: relative;
    margin: 0 auto 1.5rem;
  }
  
  /* Orbit-Kreise: nur Grautöne */
  .orbit-circle {
    position: absolute;
    inset: 0;
    border-radius: 9999px;
    border: 2px solid transparent;
  }
  
  /* Außen: dunklere Grautöne */
  .orbit-circle--outer {
    border-top-color: #777;
    border-right-color: #aaa;
    animation: spin 1.4s linear infinite;
  }
  
  /* Mitte: mittlere Grautöne */
  .orbit-circle--middle {
    inset: 12px;
    border-left-color: #999;
    border-bottom-color: #bbb;
    animation: spinReverse 1.8s linear infinite;
  }
  
  /* Innen: hellere Grautöne */
  .orbit-circle--inner {
    inset: 24px;
    border-top-color: #555;
    border-right-color: #888;
    animation: spin 2s linear infinite;
  }
  
  /* Zentraler Punkt: grauer “Glow” ohne Farbe */
  .loader-dot {
    position: absolute;
    inset: 50%;
    width: 14px;
    height: 14px;
    transform: translate(-50%, -50%);
    border-radius: 9999px;
    background: radial-gradient(circle at 30% 30%, #ddd, #555);
    box-shadow:
      0 0 20px rgba(120, 120, 120, 0.4),
      0 0 40px rgba(120, 120, 120, 0.3);
    animation: pulse 1.6s ease-in-out infinite;
  }
  
  /* Text */
  .loader-text {
    font-size: 0.95rem;
    letter-spacing: 0.12em;
    opacity: 0.9;
    text-transform: uppercase;
  }
  
  /* Punkte Animations */
  .loader-dots {
    display: inline-flex;
  }
  
  .loader-dots span {
    animation: bounce 1.4s infinite;
    display: inline-block;
  }
  
  .loader-dots span:nth-child(2) {
    animation-delay: 0.15s;
  }
  .loader-dots span:nth-child(3) {
    animation-delay: 0.3s;
  }
  
  /* Keyframes */
  @keyframes spin {
    to { transform: rotate(360deg); }
  }
  
  @keyframes spinReverse {
    to { transform: rotate(-360deg); }
  }
  
  @keyframes pulse {
    0%, 100% {
      transform: translate(-50%, -50%) scale(1);
      opacity: 1;
    }
    50% {
      transform: translate(-50%, -50%) scale(1.2);
      opacity: 0.6;
    }
  }
  
  @keyframes bounce {
    0%, 60%, 100% {
      transform: translateY(0);
      opacity: 0.4;
    }
    30% {
      transform: translateY(-3px);
      opacity: 1;
    }
  }
  </style>
  